module.exports = __webpack_public_path__ + "img/cash.d864c6ea.svg";